import { gql } from "@apollo/client";

export const GET_TERMINAL_TYPES = gql`
  query Types {
    terminal {
      types {
        terminal_type_id
        input
        val1_type
        val1_min
        val1_max
        val2_type
        val2_min
        val2_max
        extra
        time_act
        programmed
      }
    }
  }
`

export interface TerminalTypesInfo {
  __typename?: string;
  terminal_type_id: number;
  input: number;
  val1_type: number;
  val1_min: number;
  val1_max: number;
  val2_type: number;
  val2_min: number;
  val2_max: number;
  extra: number;
  time_act: number;
  programmed: number;
}

export interface TerminalTypesResponse {
  terminal: {
    types: TerminalTypesInfo[]
  }
}